'use strict';

import 'slick-carousel';

export const carousel = (() => {
    const sections = ['total_resilience', 'smart_wellness', 'future_value'];


    /**
     * init
     */
    const init = () => {

        $('.js-carousel').each((index, element) => {
            const $this = $(element);

            $this
                .not('.slick-initialized')
                .slick({
                    speed: 600,
                    cssEase: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
                    adaptiveHeight: false,
                    infinite: false,
                    centerMode: true,
                    slidesToShow: 1,
                    dots: true,
                    prevArrow:
                        '<div class="slick-arw slick-arw--prev"></div>',
                    nextArrow:
                        '<div class="slick-arw slick-arw--next"></div>',
                    responsive: [{
                        breakpoint: 769,
                        settings: {
                            // arrows: false,
                            cssEase: 'cubic-bezier(0.215, 0.61, 0.355, 1)'
                        }
                    }]
                });

            $this.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                if (nextSlide > 0) {
                    $this.parent('.js-carousel-pos').addClass('is-over');
                } else {
                    $this.parent('.js-carousel-pos').removeClass('is-over');
                }
            });
        });


        $('.js-carousel-button').on('click', event => {
            const $this = $(event.currentTarget);
            $this.closest('.js-carousel-pos').find('.js-carousel').slick('slickNext');
        });

        $('.js-goto-carousel').each((index, element) => {
            $(element).on('click', event => {
                $('#' + sections[index]).find('.js-carousel').slick('slickGoTo', 0, false);
            });
        });
    };

    return {
        init: init
    };
})();
